<template>
    <div class="profile-about-root w-full">
        <div class="inline-flex items-center px-3 py-1 rounded-full bg-indigo-100 text-indigo-800 text-xs font-semibold">
            📝 About</div>
        <h3 class="mt-4 text-2xl font-extrabold text-indigo-900">Detailed description</h3>
        <p class="mt-2 text-gray-600">A longer introduction about background, interests, and goals.</p>

        <div v-if="hasDescription" class="mt-6 rounded-xl border border-gray-200 bg-gray-50 p-5">
            <div class="profile-about-text text-gray-800 whitespace-pre-wrap">{{ description }}</div>
            <div v-if="isOwnProfile" class="mt-4 flex justify-end">
                <button type="button" @click="openEdit" title="Edit"
                    class="w-10 h-10 rounded-lg bg-white border border-gray-200 text-indigo-700 hover:bg-gray-50 hover:border-indigo-200 transition grid place-items-center shadow-sm">
                    <font-awesome-icon icon="pen" class="text-sm" />
                </button>
            </div>
        </div>

        <div v-else class="mt-6 rounded-xl border border-dashed border-gray-300 bg-white p-8 text-center">
            <p class="text-gray-600 text-sm">
                <span v-if="isOwnProfile">You have not added a detailed description yet.</span>
                <span v-else>This member has not added a detailed description yet.</span>
            </p>
            <button v-if="isOwnProfile" type="button" @click="openAdd"
                class="mt-4 px-5 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold shadow-sm transition">
                Add description
            </button>
        </div>

        <base-modal v-if="showModal" :title="modalTitle" @close="closeModal">
            <div class="p-5 space-y-4">
                <textarea v-model="draft" rows="14" placeholder="Write about yourself..."
                    class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 outline-none"></textarea>
                <p class="text-xs text-gray-500">{{ draft.length }} / 50000 characters</p>
                <div class="flex justify-end gap-2">
                    <button type="button" @click="closeModal"
                        class="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700">Cancel</button>
                    <button type="button" :disabled="saving" @click="submit"
                        class="px-5 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white disabled:opacity-60">
                        <span v-if="saving">Saving…</span>
                        <span v-else>Save</span>
                    </button>
                </div>
            </div>
        </base-modal>
    </div>
</template>

<script>
import gql from 'graphql-tag';

const UPDATE_PROFILE_DETAILS = gql`
  mutation UpdateProfileDetailsForAbout($input: UpdateProfileDetailsInput!) {
    updateProfileDetails(input: $input) {
      error
      error_code
      message
    }
  }
`;

export default {
    name: 'ProfileAbout',
    props: {
        description: {
            type: String,
            default: ''
        },
        isOwnProfile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showModal: false,
            draft: '',
            saving: false,
            modalTitle: 'Add detailed description'
        };
    },
    computed: {
        hasDescription() {
            const d = this.description;
            return d && String(d).trim().length > 0;
        }
    },
    methods: {
        openAdd() {
            this.modalTitle = 'Add detailed description';
            this.draft = '';
            this.showModal = true;
        },
        openEdit() {
            this.modalTitle = 'Edit detailed description';
            this.draft = this.description || '';
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.draft = '';
            this.saving = false;
        },
        submit() {
            var self = this;
            this.saving = true;
            this.$apollo.mutate({
                mutation: UPDATE_PROFILE_DETAILS,
                variables: { input: { detailed_description: this.draft } }
            }).then(function (res) {
                var payload = res && res.data && res.data.updateProfileDetails;
                if (payload && payload.error) {
                    if (self.$swal) {
                        self.$swal.fire({ icon: 'error', title: 'Save failed', text: payload.message || 'Please try again.' });
                    }
                    return;
                }
                if (self.$swal) {
                    self.$swal.fire({
                        icon: 'success',
                        title: (payload && payload.message) || 'Saved',
                        toast: true,
                        position: 'top-end',
                        timer: 2500,
                        showConfirmButton: false
                    });
                }
                self.closeModal();
                self.$emit('saved');
            }).catch(function () {
                if (self.$swal) {
                    self.$swal.fire({ icon: 'error', title: 'Save failed', text: 'Please try again.' });
                }
            }).finally(function () {
                self.saving = false;
            });
        }
    }
};
</script>

<style scoped>
.profile-about-root .profile-about-text {
    line-height: 1.6;
    word-break: break-word;
}
</style>
